import {
  FileText,
  ImageIcon,
  MessageSquare,
  Repeat2,
  ThumbsUp,
  Video,
} from "lucide-react";
import React, { useState, useCallback } from "react";
import Button from "../../components/form/front/Button";
import Dropdown from "../../components/form/Dropdown";
import PostComposer from "../../components/sections/front/PostComposer";
import CommonSideBar from "../../layouts/shared/CommonSideBar";



const initialJobs = [
  {
    id: 1,
    avatar: "https://i.pravatar.cc/150?img=5",
    recruiterName: "Debasmita Samaddar",
    designation: "Technical Recruiter at Yash Technologies",
    companyName: "YASH Technologies",
    jobPost: "https://i.pravatar.cc/150?img=5",
    location: "Pune, Maharashtra, India (Hybrid)",
    role: "Senior Software Engineer",
    like: 54,
    isLike: false,
    comment: [
      {
        id: 1,
        user: "Vigneshwaran Sharma",
        text: "Despite Oscar and Golden Globe nominations and the unshakeable respect of film critics and his acting peers, Robert Downey, Jr. insisted that he was not really an actor, just a good hustler who had found a way to make a living.",
        isLike: false,
        totalReply: null,
        replies: [
          {
            id: 1,
            user: "Robert Downey Jr.",
            text: "Robert John Downey Jr. is an American actor. His films as a leading actor have grossed over $14.3 billion worldwide, making him one of the highest-grossing actors of all time. Downey was the highest-paid actor in the world annually from 2013 to 2015",
            isLike: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/150?img=12",
    recruiterName: "Debasmita Samaddar",
    designation: "Technical Recruiter at Yash Technologies",
    companyName: "YASH Technologies",
    jobPost: "https://i.pravatar.cc/150?img=5",
    location: "Pune, Maharashtra, India (Hybrid)",
    role: "Senior Software Engineer",
    like: 21,
    isLike: false,
    comment: [
      {
        id: 1,
        user: "Vigneshwaran Sharma",
        text: "just a good hustler who had found a way to make a living.",
        isLike: false,
        totalReply: null,
        replies: [],
      },
    ],
  },
  {
    id: 3,
    avatar: "https://i.pravatar.cc/150?img=25",
    recruiterName: "Debasmita Samaddar",
    designation: "Technical Recruiter at Yash Technologies",
    companyName: "YASH Technologies",
    jobPost: "https://i.pravatar.cc/150?img=5",
    location: "Pune, Maharashtra, India (Hybrid)",
    role: "Senior Software Engineer",
    like: 1250,
    isLike: false,
    comment: [
      {
        id: 1,
        user: "Vigneshwaran Sharma",
        text: "Despite Oscar and Golden Globe nominations and the unshakeable respect of film critics and his acting peers, Robert Downey, Jr. insisted that he was not really an actor, just a good hustler who had found a way to make a living.",
        isLike: false,
        totalReply: null,
        replies: [
          {
            id: 1,
            user: "Robert Downey Jr.",
            text: "Robert John Downey Jr. is an American actor. His films as a leading actor have grossed over $14.3 billion worldwide, making him one of the highest-grossing actors of all time. Downey was the highest-paid actor in the world annually from 2013 to 2015",
            isLike: false,
          },
        ],
      },
    ],
  },
];


const Post = () => {
  const [jobs, setJobs] = useState(initialJobs);
  const [showComment, setShowComment] = useState({});
  const [commentInputs, setCommentInputs] = useState({});

  const handleLike = useCallback((id) => {
    setJobs((prev) =>
      prev.map((job) => {
        if (job.id !== id) return job;

        const updatedIsLike = !job.isLike;

        return {
          ...job,
          isLike: updatedIsLike,
          like: updatedIsLike ? job.like + 1 : job.like - 1,
        };
      }),
    );
  }, []);

  const handleToggleComment = useCallback((id) => {
    setShowComment((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  }, []);

  const handleCommentChange = useCallback((id, value) => {
    setCommentInputs((prev) => ({
      ...prev,
      [id]: value,
    }));
  }, []);

  const handleAddComment = useCallback(
    (id) => {
      const text = commentInputs[id]?.trim();
      if (!text) return;

      setJobs((prev) =>
        prev.map((job) =>
          job.id === id
            ? {
              ...job,
              comment: [
                ...job.comment,
                {
                  id: Date.now(),
                  text,
                },
              ],
            }
            : job,
        ),
      );

      setCommentInputs((prev) => ({
        ...prev,
        [id]: "",
      }));
    },
    [commentInputs],
  );

  const optionMenu = [
    {
      icon: "fa-regular fa-bookmark",
      name: "Save",
      click: () => alert("Saved Post"),
    },
    {
      icon: "fa-solid fa-link",
      name: "Copy Post Link",
      click: () => { },
    },
    {
      icon: "fa-regular fa-eye-slash",
      name: "Hide",
      click: () => { },
    },
    {
      icon: "fa-solid fa-code",
      name: "Embed this Post",
      click: () => { },
    },
  ];

  return (
    <div className="space-y-6">
      <PostComposer />

      {jobs.map((job) => (
        <div
          key={job.id}
          className="p-4 mb-6 bg-white rounded-xl shadow-md relative border-b-2 border-palatte2"
        >
          <div className="flex items-center gap-3">
            <img
              src={job.avatar}
              alt="profile"
              className="w-12 h-12 rounded-full"
            />

            <div className="flex-1">
              <h3 className="text-base font-semibold text-gray-800">
                {job.recruiterName}
              </h3>
              <p className="text-xs font-medium text-gray-500">
                {job.designation}
              </p>
              <p className="text-xs text-gray-400">4w •</p>
            </div>
            <Dropdown
              data={optionMenu}
              xPlacement="bottomRight"
              buttonClasses="p-0 border-0"
              dropdownContainer="w-52"
              button={
                <div className="w-9 h-9 flex items-center justify-center rounded-full  text-gray-700 hover:bg-gray-100 cursor-pointer">
                  <i className="fa-solid fa-ellipsis text-xl text-palatte"></i>
                </div>
              }
            />
          </div>

          <div className="mt-3 text-[13px] font-medium text-gray-700">
            <p>Hello Connections!!</p>
            <p>
              We're
              <span className="text-blue-600 font-medium">
                #Hiring
              </span> !! {job.role}
            </p>
          </div>

          <div className="mt-4 border border-gray-300 shadow-[0_0_8px_rgba(0,0,0,0.1)] rounded-xl p-3 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src={job.jobPost}
                alt="company"
                className="w-14 h-14 rounded"
              />
              <div>
                <h4 className="text-base font-semibold text-gray-800">
                  {job.role}
                </h4>
                <p className="text-xs text-gray-700 font-medium">
                  Job by {job.companyName}
                </p>
                <p className="text-xs text-gray-700 font-medium">
                  {job.location}
                </p>
              </div>
            </div>
            <Button
              buttonLabel="View job"
              buttonHasLink
              buttonClasses="bg-white text-palatte hover:bg-transparent hover:text-white px-4 h-8 rounded-full border-palatte/50 border hover:bg-palatte2 font-medium"
              buttonLabelClasses="text-sm"
            />
          </div>

          <div className="flex justify-between text-[13px] font-medium text-gray-500 py-3 border-b border-palatte2">
            <span>{job.like} Likes</span>
            <span>{job.comment.length} comments</span>
          </div>

          <div className="flex justify-around text-sm font-medium text-gray-800 mt-3">
            <button
              onClick={() => handleLike(job.id)}
              className={`flex items-center gap-1 ${job.isLike ? "text-palatte font-medium" : ""
                }`}
            >
              <ThumbsUp size={16} />
              <span>Like</span>
            </button>

            <button
              onClick={() => handleToggleComment(job.id)}
              className="flex items-center gap-1"
            >
              <MessageSquare size={16} />
              Comment
            </button>
          </div>

          {showComment[job.id] && (
            <div className="mt-4">
              <div className="flex items-center gap-2 mt-2">
                <div className="w-10 h-10 rounded-full overflow-hidden">
                  <img
                    src="https://i.pravatar.cc/150?img=8"
                    alt="user"
                    className="w-10 h-10"
                  />
                </div>

                <input
                  type="text"
                  value={commentInputs[job.id] || ""}
                  onChange={(e) =>
                    handleCommentChange(job.id, e.target.value)
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleAddComment(job.id);
                    }
                  }}
                  placeholder="Write a comment..."
                  className="flex-1 px-3 py-2 h-10 text-sm rounded-full border-gray-300  shadow-[0_0_8px_rgba(0,0,0,0.1)] outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
                />
              </div>

              {job.comment.map((c) => (
                <div key={c.id} className="mt-4">
                  <div className="flex gap-3">
                    <img
                      src="https://i.pravatar.cc/40"
                      alt=""
                      className="w-8 h-8 rounded-full"
                    />

                    <div className="flex-1">
                      <div className="bg-white px-3 py-2">
                        <div className="flex items-center justify-between gap-2">
                          <p className="text-sm font-semibold">{c.user}</p>
                          <span className="text-xs text-gray-700">3h</span>
                        </div>
                        <p className="text-sm font-normal text-gray-500">
                          {c.text.length > 200
                            ? c.text.slice(0, 200) + " ...More"
                            : c.text}
                        </p>
                      </div>

                      <div className="flex gap-4 text-xs font-medium text-gray-500 mt-1 ml-2">
                        <button>Like</button>
                        <button>
                          {c.replies?.length > 0
                            ? `Reply ${c.replies?.length}`
                            : "Reply"}
                        </button>
                        <span>{c.time}</span>
                      </div>

                      {c.replies?.length > 0 && (
                        <div className="mt-3 ml-6 space-y-3">
                          {c.replies.map((r) => (
                            <div key={r.id} className="flex gap-3">
                              <img
                                src="https://i.pravatar.cc/35"
                                alt=""
                                className="w-7 h-7 rounded-full"
                              />

                              <div className="flex-1">
                                <div className="bg-white px-3 py-2">
                                  <div className="flex items-center justify-between gap-2">
                                    <p className="text-sm font-semibold">
                                      {r.user}
                                    </p>
                                    <span className="text-xs text-gray-700">
                                      15m
                                    </span>
                                  </div>
                                  <p className="text-sm font-normal text-gray-500">
                                    {r.text.length > 200
                                      ? r.text.slice(0, 200) + " ...More"
                                      : r.text}
                                  </p>
                                </div>

                                <div className="flex gap-4 text-xs font-medium text-gray-500 mt-1 ml-2">
                                  <button>Like</button>
                                  <button>
                                    {r.replies?.length > 0
                                      ? `Reply ${r.replies?.length}`
                                      : "Reply"}
                                  </button>
                                  <span>{r.time}</span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Post;
